import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromInstagram from '../reducers/instagram.reducer';
import { InstaPost } from '../../models';
import * as fromRoot from '../../../store';

export const getInstagramState = createSelector(
  fromFeature.getInstagramModuleState,
  (state: fromFeature.InstagramModuleState) => state.instaPosts
);

export const getInstaPostsEntities = createSelector(getInstagramState, fromInstagram.getInstaPostsEntities);

export const getAllInstaPosts = createSelector(getInstaPostsEntities, entities => {
  return Object.keys(entities).map(id => entities[id as unknown as number]);
});

export const getOrderedInstaPosts = createSelector(getAllInstaPosts, (instaPosts: InstaPost[]) => {
  return instaPosts?.sort((a, b) => new Date(b.uploadedOn).getTime() - new Date(a.uploadedOn).getTime());
});

export const getInstaPostsLoaded = createSelector(getInstagramState, fromInstagram.getInstaPostsLoaded);
export const getInstaPostsLoading = createSelector(getInstagramState, fromInstagram.getInstaPostsLoading);
